var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "footerFixed" };
const _hoisted_3 = {
    id: "all_wrapper",
    class: "user_home"
};
const _hoisted_4 = { class: "wrapper_1" };
const _hoisted_5 = {
    key: 0,
    class: "alert alert-info alert-dismissible",
    id: "alert-box"
};
const _hoisted_6 = { class: "alert-text" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { "aria-hidden": "true" }, "×", -1);
const _hoisted_8 = [
    _hoisted_7
];
const _hoisted_9 = { class: "h_box" };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { key: 1 };
const _hoisted_12 = { key: 2 };
const _hoisted_13 = { class: "h_right" };
const _hoisted_14 = {
    key: 0,
    style: { "color": "red", "font-size": "19px", "border": "solid 1px red", "padding": "15px", "margin": "0px 15px" }
};
const _hoisted_15 = { class: "inner search_box" };
const _hoisted_16 = { class: "nav" };
const _hoisted_17 = { style: { "cursor": "pointer" } };
const _hoisted_18 = ["onClick"];
const _hoisted_19 = {
    key: 0,
    class: "point"
};
const _hoisted_20 = { class: "condition" };
const _hoisted_21 = { class: "sel_wrapper" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("p", null, "相談タイプ", -1);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, null, -1);
const _hoisted_24 = ["value"];
const _hoisted_25 = { class: "sel_wrapper" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("p", null, "相談者業種", -1);
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("option", { value: "" }, null, -1);
const _hoisted_28 = ["value"];
const _hoisted_29 = { class: "comment_box" };
const _hoisted_30 = { class: "inner" };
const _hoisted_31 = {
    key: 0,
    class: "check"
};
const _hoisted_32 = { class: "prof" };
const _hoisted_33 = { class: "left" };
const _hoisted_34 = { class: "ph" };
const _hoisted_35 = { class: "ca_1" };
const _hoisted_36 = { class: "ca_2" };
const _hoisted_37 = { class: "right" };
const _hoisted_38 = {
    key: 0,
    class: "ca_1"
};
const _hoisted_39 = {
    key: 1,
    class: "ca_3"
};
const _hoisted_40 = {
    key: 2,
    class: "ca_2"
};
const _hoisted_41 = { class: "w_box" };
const _hoisted_42 = ["href"];
const _hoisted_43 = {
    class: "lead",
    style: { "white-space": "pre-line" }
};
const _hoisted_44 = { class: "under" };
const _hoisted_45 = { class: "left" };
const _hoisted_46 = { class: "answer" };
const _hoisted_47 = { class: "heart" };
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-heart" }, null, -1);
const _hoisted_49 = { class: "right" };
import { inject, ref, watch, computed, onBeforeMount, onMounted, nextTick } from 'vue';
import { Link } from '@inertiajs/inertia-vue3';
import axios from 'axios';
import { Inertia } from '@inertiajs/inertia';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import InertiaUtil from '@util/InertiaUtil';
import Formatter from '@util/Formatter';
import { AuthRole, QuestionType } from '@util/Consts';
import JobsModal from '@component/Modals/UserHome/JobModal.vue';
import ImageFrame from '@component/ImageFrame.vue';
import Pagination from '@component/QuestionPagination.vue';
import swal from 'sweetalert';
import { loadStripe } from '@stripe/stripe-js';
export default /*#__PURE__*/ _defineComponent({
    __name: 'user_home',
    props: {
        common: null,
        checkExpire: null,
        additionalQuestionMsg: null,
        questions: null,
        question_option_types: null,
        unread_reply_question_count: null,
        success_message: null,
        createQuestionAvailable: null,
        payment_intent_client_secret: null
    },
    setup(__props) {
        const props = __props;
        let stripe = null;
        const USER_HOME_SEARCH_SESSION_KEY = 'user-home-search';
        const form = InertiaUtil.getForm({
            job_group_id: null,
            job_id: null,
            other_job_name: '',
            option_type: null,
            question_type_id: null,
            industry_id: null,
            mentor_type: null,
            keyword: null,
        });
        const typeOptions = ref([]);
        const industryOptions = ref([]);
        const jobOptions = ref([]);
        const auth_3ds_complete = ref('loading');
        const MAX_UNREAD_COUNT = 99;
        const showUnread = computed(() => props.unread_reply_question_count <= MAX_UNREAD_COUNT
            ? props.unread_reply_question_count.toString()
            : `${MAX_UNREAD_COUNT}+`);
        // 文字数チェック
        watch(() => form.keyword, (value) => {
            if (Alert.charLimitText(value)) {
                form.keyword = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        const onClickTo3DSpage = () => {
            Inertia.get(route('user.3ds_confirm'));
        };
        const onClickToPlanPage = () => {
            Inertia.get(route('payment.show'));
        };
        // メンター職種選択イベント
        const onSelectedJob = (job) => {
            var _a, _b, _c;
            form.job_group_id = (_a = job === null || job === void 0 ? void 0 : job.job_group_id) !== null && _a !== void 0 ? _a : '';
            form.job_id = (_b = job === null || job === void 0 ? void 0 : job.job_id) !== null && _b !== void 0 ? _b : '';
            form.other_job_name = (_c = job === null || job === void 0 ? void 0 : job.other_job_name) !== null && _c !== void 0 ? _c : '';
        };
        // 検索
        const onClickSearch = () => {
            sessionStorage.setItem(USER_HOME_SEARCH_SESSION_KEY, JSON.stringify(form));
            form.get(route('question.index'), { preserveState: true });
        };
        const onClickQuestionType = (type) => {
            form.option_type = type.toString();
            sessionStorage.setItem(USER_HOME_SEARCH_SESSION_KEY, JSON.stringify(form));
            form.get(route('question.index'), {});
        };
        const onClickCloseAlert = () => {
            document.getElementById('alert-box').style.display = 'none';
        };
        onBeforeMount(() => __awaiter(this, void 0, void 0, function* () {
            const publishableKey = inject('stripePublicKey');
            const secretKey = inject('stripeSecretKey');
            const stripePromise = loadStripe(publishableKey);
            const stripe = yield stripePromise;
            if (props.payment_intent_client_secret) {
                // this means 3ds auth case
                const payment_intent_client_secret = props.payment_intent_client_secret;
                const result = yield stripe.retrievePaymentIntent(payment_intent_client_secret);
                if (result.error) {
                    // PaymentIntent client secret was invalid
                    auth_3ds_complete.value = "failed";
                }
                else {
                    if (result.paymentIntent.status === 'requires_payment_method') {
                        // Authentication failed
                        Inertia.get(route('question.confirm'));
                        swal({
                            title: "確認",
                            text: "クレジットカードの認証に失敗し、相談は受付られませんでした。必要により支払方法登録画面で別カードの登録をご検討ください。",
                            icon: "warning",
                            buttons: {
                                ok: {
                                    text: "OK",
                                    className: "timeout-ok-btn",
                                },
                            },
                        })
                            .then(() => {
                            auth_3ds_complete.value = "failed";
                        });
                    }
                    else {
                        // 3ds success
                        sessionStorage.removeItem('oldQuestionForm');
                        auth_3ds_complete.value = "success";
                    }
                }
            }
            else {
                // this means no 3ds auth case
                auth_3ds_complete.value = "success";
            }
            if (props.checkExpire) {
                Alert.Error(props.checkExpire);
            }
            ;
            if (props.additionalQuestionMsg) {
                Alert.Error(props.additionalQuestionMsg);
            }
            ;
            const [types, industries, jobs] = yield Promise.all([
                axios
                    .get('question-types-trashed')
                    .then(res => res.data)
                    .catch(e => []),
                axios
                    .get('industries')
                    .then(res => res.data)
                    .catch(e => []),
                axios
                    .get('jobs')
                    .then(res => res.data)
                    .catch(e => []),
            ]);
            typeOptions.value = types;
            industryOptions.value = industries;
            jobOptions.value = jobs;
        }));
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            const storage = JSON.parse(sessionStorage.getItem(USER_HOME_SEARCH_SESSION_KEY));
            nextTick(() => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                // 既に読み込まれていたら一旦削除して、読み込み直す。
                var key = require.resolve('@jquery/modal-jquery');
                if (key)
                    delete require.cache[key];
                require('@jquery/modal-jquery');
                let uri = window.location.search.substring(1);
                let params = new URLSearchParams(uri);
                form.option_type = (_b = (_a = storage === null || storage === void 0 ? void 0 : storage.option_type) !== null && _a !== void 0 ? _a : params.get('option_type')) !== null && _b !== void 0 ? _b : QuestionType.ALL.toString();
                form.job_group_id = (_c = storage === null || storage === void 0 ? void 0 : storage.job_group_id) !== null && _c !== void 0 ? _c : params.get('job_group_id');
                form.job_id = (_d = storage === null || storage === void 0 ? void 0 : storage.job_id) !== null && _d !== void 0 ? _d : params.get('job_id');
                form.question_type_id = (_e = storage === null || storage === void 0 ? void 0 : storage.question_type_id) !== null && _e !== void 0 ? _e : params.get('question_type_id');
                form.industry_id = (_f = storage === null || storage === void 0 ? void 0 : storage.industry_id) !== null && _f !== void 0 ? _f : params.get('industry_id');
                form.mentor_type = (_g = storage === null || storage === void 0 ? void 0 : storage.mentor_type) !== null && _g !== void 0 ? _g : params.get('mentor_type');
                form.keyword = (_h = storage === null || storage === void 0 ? void 0 : storage.keyword) !== null && _h !== void 0 ? _h : params.get('keyword');
            });
        }));
        return (_ctx, _cache) => {
            var _a;
            return (auth_3ds_complete.value !== 'loading')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(headerVue, {
                        common: props.common
                    }, null, 8, ["common"]),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                (props.success_message)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createElementVNode("p", _hoisted_6, _toDisplayString(props.success_message), 1),
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "close",
                                            onClick: onClickCloseAlert
                                        }, _hoisted_8)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_9, [
                                    (props.common.role === _unref(AuthRole).QUESTIONER)
                                        ? (_openBlock(), _createElementBlock("h2", _hoisted_10, "相談者ホーム"))
                                        : (props.common.role === _unref(AuthRole).MENTOR)
                                            ? (_openBlock(), _createElementBlock("h2", _hoisted_11, "メンターホーム"))
                                            : (_openBlock(), _createElementBlock("h2", _hoisted_12, "管理者ホーム")),
                                    _createElementVNode("div", _hoisted_13, [
                                        (!(props.common.role === _unref(AuthRole).MENTOR || props.common.role === _unref(AuthRole).ADMIN))
                                            ? (_openBlock(), _createBlock(_unref(Link), {
                                                key: 0,
                                                class: _normalizeClass({ disabled_link: !props.createQuestionAvailable }),
                                                href: "/question/create"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode("相談する ")
                                                ]),
                                                _: 1
                                            }, 8, ["class"]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]),
                                _createElementVNode("div", null, [
                                    (props.common.role === _unref(AuthRole).QUESTIONER && !props.createQuestionAvailable)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                            _createTextVNode(" クレジットカードが利用不可となっています。 "),
                                            _createElementVNode("a", {
                                                style: { "color": "red", "cursor": "pointer" },
                                                onClick: onClickToPlanPage
                                            }, "こちら"),
                                            _createTextVNode(" から今月の決済を完了してください。 ")
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("form", null, [
                                        _createElementVNode("ul", _hoisted_16, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.question_option_types, (value, key, _) => {
                                                return (_openBlock(), _createElementBlock("li", _hoisted_17, [
                                                    _createElementVNode("a", {
                                                        class: _normalizeClass({ active: key.toString() == _unref(form).option_type }),
                                                        onClick: ($event) => (onClickQuestionType(key))
                                                    }, [
                                                        _createTextVNode(_toDisplayString(value) + " ", 1),
                                                        (_unref(QuestionType).REPLY_UNREAD == key && props.unread_reply_question_count > 0)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(showUnread)), 1))
                                                            : _createCommentVNode("", true)
                                                    ], 10, _hoisted_18)
                                                ]));
                                            }), 256))
                                        ]),
                                        _createElementVNode("ul", _hoisted_20, [
                                            _createElementVNode("li", null, [
                                                _createElementVNode("div", _hoisted_21, [
                                                    _hoisted_22,
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).question_type_id) = $event)),
                                                        autofocus: ""
                                                    }, [
                                                        _hoisted_23,
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeOptions.value, (questionType) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: questionType.id
                                                            }, _toDisplayString(questionType.name), 9, _hoisted_24));
                                                        }), 256))
                                                    ], 512), [
                                                        [_vModelSelect, _unref(form).question_type_id]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("li", null, [
                                                _createElementVNode("div", _hoisted_25, [
                                                    _hoisted_26,
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).industry_id) = $event))
                                                    }, [
                                                        _hoisted_27,
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industryOptions.value, (industry) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                value: industry.id
                                                            }, _toDisplayString(industry.name), 9, _hoisted_28));
                                                        }), 256))
                                                    ], 512), [
                                                        [_vModelSelect, _unref(form).industry_id]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("li", null, [
                                                _createVNode(JobsModal, {
                                                    form: _unref(form),
                                                    options: jobOptions.value,
                                                    placeholder: "対象メンター職種",
                                                    onSelected: onSelectedJob,
                                                    "max-length": 19
                                                }, null, 8, ["form", "options"])
                                            ]),
                                            _createElementVNode("li", null, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).keyword) = $event)),
                                                    class: "",
                                                    type: "text",
                                                    placeholder: "キーワード入力",
                                                    id: "consultationRaw__input"
                                                }, null, 512), [
                                                    [_vModelText, _unref(form).keyword]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("button", {
                                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (onClickSearch()), ["prevent"]))
                                        }, "検索")
                                    ])
                                ]),
                                _createVNode(Pagination, {
                                    questions: props.questions
                                }, null, 8, ["questions"]),
                                _createElementVNode("div", _hoisted_29, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_a = props.questions) === null || _a === void 0 ? void 0 : _a.data, (display) => {
                                        var _a, _b;
                                        return (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                            (!display.is_read)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_31))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_32, [
                                                _createElementVNode("div", _hoisted_33, [
                                                    _createElementVNode("div", _hoisted_34, [
                                                        _createVNode(ImageFrame, {
                                                            src: display.user.photo
                                                        }, null, 8, ["src"])
                                                    ]),
                                                    _createVNode(_unref(Link), {
                                                        href: `/user/${display.user.id}`
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(display.user.name), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["href"]),
                                                    _createElementVNode("div", _hoisted_35, _toDisplayString((_a = display.user.industry) === null || _a === void 0 ? void 0 : _a.name), 1),
                                                    _createElementVNode("div", _hoisted_36, _toDisplayString((_b = display.question_type) === null || _b === void 0 ? void 0 : _b.name), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_37, [
                                                    (display.status == _unref(QuestionType).ACCEPTING)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, "受付中"))
                                                        : _createCommentVNode("", true),
                                                    (display.status == _unref(QuestionType).UNDER_EVALUATION)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, "評価中"))
                                                        : _createCommentVNode("", true),
                                                    (display.status == _unref(QuestionType).ACCEPTED)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_40, "受付済"))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_41, [
                                                _createElementVNode("a", {
                                                    class: "title",
                                                    href: `/question/${display.id}`,
                                                    target: "_blank"
                                                }, _toDisplayString(display.subject), 9, _hoisted_42),
                                                _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(Formatter).formatCharOmit(display.content, 180)), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_44, [
                                                _createElementVNode("div", _hoisted_45, [
                                                    _createElementVNode("p", _hoisted_46, [
                                                        _createElementVNode("span", null, _toDisplayString(display.answer_count), 1),
                                                        _createTextVNode("回答 ")
                                                    ]),
                                                    _createElementVNode("p", _hoisted_47, [
                                                        _hoisted_48,
                                                        _createTextVNode(_toDisplayString(display.like_count), 1)
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_49, _toDisplayString(_unref(Formatter).formatDate(display.created_at, 'YYYY年MM月DD日 HH:mm')), 1)
                                            ])
                                        ]));
                                    }), 256))
                                ]),
                                _createVNode(Pagination, {
                                    questions: props.questions
                                }, null, 8, ["questions"])
                            ])
                        ]),
                        _createVNode(footerVue)
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
